import React from 'react';

import Input from '../Input';

const ResearchDirection = (props) => (
    <Input label="研究方向" name="researchDirection" {...props}></Input>
);

export default ResearchDirection;